import { apiUrlFor } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_FLOORPLANS=true in .env.local for the local API.
export const API_URL = apiUrlFor(process.env.REACT_APP_LOCAL_API_FLOORPLANS);
